import { memo, useContext, useEffect, useRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Route, Routes, useLocation, useMatch } from "react-router-dom";
import { AsyncSmartDPBooking, AsyncSmartDPListingContainer } from "app/routes";
import SmartDPStepper from "app/pages/SmartDP/Booking/SmartDPStepper/SmartDPStepper";
import SmartDPHotelDescriptionContainer from "app/pages/SmartDP/Quote/HotelDescription/SmartDPHotelDescriptionContainer";
import { QUOTATION_CODE_STATUS, WEBSITE_TUNNEL_TYPES } from "app/constants";
import HeaderContainer from "app/pages/Header/HeaderContainer";
import useHidePartnerCustomHeader from "app/utils/hooks/useHidePartnerCustomHeader";

import "./SmartDP.scss";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AppGlobalsContext from "app/AppGlobalsContext";
import HomeLayoutContainer from "app/pages/HomeLayout/HomeLayoutContainer";

const SmartDP = ({
	homeBlocks = [],
	fetchSDPProductsStatus,
	fetchSDPAvailabilitiesStatus,
	fetchSDPFilters = () => {},
}) => {
	const { pathname } = useLocation();
	const { resolution } = useContext(AppGlobalsContext);

	const smartDPRef = useRef(null);

	const isSdpSearchPage = pathname.includes("sdp/search");

	const isSDPSearchPage = useMatch({
		path: "/sdp/search",
		end: true,
		caseSensitive: true,
	});
	const isSDPRootPage = useMatch({
		path: "/",
		end: true,
		caseSensitive: true,
	});

	const headerClass = classNames("smartdp", {
		"smartdp--search": isSDPRootPage || isSDPSearchPage,
	});

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	useHidePartnerCustomHeader({ hide: !isSdpSearchPage && !isSDPRootPage });

	const isLoadingSDPListing = fetchSDPProductsStatus === QUOTATION_CODE_STATUS.LOADING;

	const isLoadingSdpQuote = fetchSDPAvailabilitiesStatus === QUOTATION_CODE_STATUS.LOADING;

	useEffect(() => {
		fetchSDPFilters();
	}, []);

	return (
		<div className={headerClass} ref={smartDPRef}>
			<Routes>
				<Route path="/search" element={null} />
				<Route
					path="/hotelDescription/:accommodationId/:code"
					element={
						<HeaderContainer showMenuItems showDialPhone={false} showBackBtn={false} />
					}
				/>
				<Route
					path="/listing/*"
					element={
						<HeaderContainer
							showMenuItems
							showMiniSearch
							showDialPhone={false}
							showBackBtn
							displayLoader={isLoadingSDPListing}
						/>
					}
				/>
				<Route
					path="/listing/map"
					element={
						isMobile ? (
							<></>
						) : (
							<HeaderContainer
								showMenuItems
								showMiniSearch
								showDialPhone={false}
								showBackBtn
								displayLoader={isLoadingSDPListing}
							/>
						)
					}
				/>
				<Route
					path="/booking/payment"
					element={<HeaderContainer showMenuItems={false} showDialPhone showBackBtn />}
				/>
				<Route
					path="/booking/quote"
					element={
						<HeaderContainer
							showMenuItems={false}
							showDialPhone
							showBackBtn
							displayLoader={isLoadingSdpQuote}
						/>
					}
				/>
				<Route
					path="/booking/*"
					element={
						<HeaderContainer showMenuItems={false} showDialPhone={false} showBackBtn />
					}
				/>
				<Route path="/" element={null} />
			</Routes>

			<Routes>
				<Route
					path="/booking/*"
					element={
						<div className="smartdp__stepper">
							<SmartDPStepper />
						</div>
					}
				/>
			</Routes>
			<Routes>
				<Route
					path="/search"
					element={
						<HomeLayoutContainer
							homeBlocks={homeBlocks}
							websiteTunnels={[{ websiteTunnelType: WEBSITE_TUNNEL_TYPES.HOLIDAYS }]}
						/>
					}
				/>
				<Route
					path="/hotelDescription/:accommodationId/:code"
					element={<SmartDPHotelDescriptionContainer printMode={true} />}
				/>
				<Route path="/listing/*" element={<AsyncSmartDPListingContainer />} />
				<Route path="/booking/*" element={<AsyncSmartDPBooking />} />
				<Route
					path="/"
					element={
						<HomeLayoutContainer
							homeBlocks={homeBlocks}
							websiteTunnels={[{ websiteTunnelType: WEBSITE_TUNNEL_TYPES.HOLIDAYS }]}
						/>
					}
				/>
			</Routes>
		</div>
	);
};

SmartDP.propTypes = {
	homeBlocks: PropTypes.array,
	fetchSDPProductsStatus: PropTypes.string,
	fetchSDPAvailabilitiesStatus: PropTypes.string,
	fetchSDPFilters: PropTypes.func,
};

export default memo(SmartDP);
